import * as yup from 'yup'
import { openChat } from '@client/utils/chatbot'
import sendSegmentEvent from '@client/utils/segmentHelper'

export default [
  {
    id: 'first-name',
    name: 'firstName',
    label: 'smb_acquisition_personal_info.fields.first_name.placeholder',
    componentType: 'input',
    columnSize: {
      small: 12,
      medium: 6,
    },
    validations: {
      primitiveType: 'string',
      noHtmlTag: true,
      required: true,
    },
  },

  {
    id: 'last-name',
    name: 'lastName',
    label: 'smb_acquisition_personal_info.fields.last_name.placeholder',
    componentType: 'input',
    columnSize: {
      small: 12,
      medium: 6,
    },
    validations: {
      primitiveType: 'string',
      required: true,
    },
  },

  {
    id: 'email',
    name: 'email',
    label: 'smb_acquisition_personal_info.fields.email.placeholder',
    componentType: 'input',
    columnSize: {
      small: 12,
      medium: 6,
    },
    validations: {
      primitiveType: 'string',
      email: true,
      required: true,
    },
  },

  {
    id: 'client-mobile-phone',
    name: 'mobilePhone',
    label: 'smb_acquisition_personal_info.fields.phone.placeholder',
    componentType: 'input',
    columnSize: {
      small: 12,
      medium: 6,
    },
    options: {
      mask: '(999) 999-9999',
    },
    validations: {
      primitiveType: 'string',
      required: true,
      min: 10,
      phone: true,
    },
  },
  {
    id: 'company',
    name: 'company',
    label: 'smb_acquisition_company_info.fields.company_name.placeholder',
    componentType: 'input',
    columnSize: {
      small: 12,
      medium: 6,
    },
    validations: {
      primitiveType: 'string',
      required: true,
    },
  },
  {
    id: 'companyinfo-role',
    name: 'role',
    label: 'smb_acquisition_form.fields.role.placeholder',
    componentType: 'select',
    columnSize: {
      small: 12,
      medium: 6,
    },
    items: {
      translation: true,
      defaultElements: {
        insertionMode: 'before', // after, mergeAndSort, clean
        elements: [
          { value: '', name: '' },
          {
            value: 'Trainee_Intern',
            intlKey: 'smb_acquisition_form.fields.role.options.trainee_intern',
            name: 'Trainee Intern',
          },
          {
            value: 'Analyst',
            intlKey: 'smb_acquisition_form.fields.role.options.analyst',
            name: 'Analyst',
          },
          {
            value: 'Board Member',
            intlKey: 'smb_acquisition_form.fields.role.options.board_member',
            name: 'Board Member',
          },
          {
            value: 'CEO',
            intlKey: 'smb_acquisition_form.fields.role.options.ceo',
            name: 'CEO',
          },
          {
            value: 'CFO',
            intlKey: 'smb_acquisition_form.fields.role.options.cfo',
            name: 'CFO',
          },
          {
            value: 'CHRO',
            intlKey: 'smb_acquisition_form.fields.role.options.chro',
            name: 'CHRO',
          },
          {
            value: 'Consultant',
            intlKey: 'smb_acquisition_form.fields.role.options.consultant',
            name: 'Consultant',
          },
          {
            value: 'Coordinator',
            intlKey: 'smb_acquisition_form.fields.role.options.coordinator',
            name: 'Coordinator',
          },
          {
            value: 'Director',
            intlKey: 'smb_acquisition_form.fields.role.options.director',
            name: 'Director',
          },
          {
            value: 'Doctor',
            intlKey: 'smb_acquisition_form.fields.role.options.doctor',
            name: 'Doctor',
          },
          {
            value: 'Executive Assistant',
            intlKey:
              'smb_acquisition_form.fields.role.options.executive_assistant',
            name: 'Executive Assistant',
          },
          {
            value: 'Manager',
            intlKey: 'smb_acquisition_form.fields.role.options.manager',
            name: 'Manager',
          },
          {
            value: 'Supervisor',
            intlKey: 'smb_acquisition_form.fields.role.options.supervisor',
            name: 'Supervisor',
          },
          {
            value: 'Vice President',
            intlKey: 'smb_acquisition_form.fields.role.options.vice_president',
            name: 'Vice President',
          },
        ],
      },
    },
    validations: {
      primitiveType: 'string',
      required: true,
    },
  },
  {
    id: 'state',
    name: 'state',
    label:
      'smb_acquisition_company_info.fields.headquarter_location.placeholder',
    componentType: 'select',
    columnSize: {
      small: 12,
      medium: 6,
    },
    items: {},
    validations: {
      primitiveType: 'string',
      required: true,
    },
  },
  {
    id: 'companyinfo-department',
    name: 'department',
    label: 'smb_acquisition_form.fields.department.placeholder',
    componentType: 'select',
    columnSize: {
      small: 12,
      medium: 6,
    },
    items: {
      translation: true,
      defaultElements: {
        insertionMode: 'before', // after, mergeAndSort, clean
        elements: [
          { value: '', name: '' },
          {
            value: 'Business Relationships',
            intlKey:
              'smb_acquisition_form.fields.department.options.business_relationships',
            name: 'Business Relationships',
          },
          {
            value: 'C-level',
            intlKey: 'smb_acquisition_form.fields.department.options.c_level',
            name: 'C-level',
          },
          {
            value: 'Compensation and benefits',
            intlKey:
              'smb_acquisition_form.fields.department.options.compensation_benefits',
            name: 'Compensation and benefits',
          },
          {
            value: 'EHS (Environment, Health and Safety)',
            intlKey:
              'smb_acquisition_form.fields.department.options.environment_healthy_safety',
            name: 'Environment, Health and Safety',
          },
          {
            value: 'Finance',
            intlKey: 'smb_acquisition_form.fields.department.options.finance',
            name: 'Finance',
          },
          {
            value: 'Human Resources',
            intlKey:
              'smb_acquisition_form.fields.department.options.human_resources',
            name: 'Human Resources',
          },
          {
            value: 'Internal communication',
            intlKey:
              'smb_acquisition_form.fields.department.options.internal_communication',
            name: 'Internal communication',
          },
          {
            value: 'Legal',
            intlKey: 'smb_acquisition_form.fields.department.options.legal',
            name: 'Legal',
          },
          {
            value: 'Marketing',
            intlKey: 'smb_acquisition_form.fields.department.options.marketing',
            name: 'Marketing',
          },
          {
            value: 'Operations',
            intlKey:
              'smb_acquisition_form.fields.department.options.operations',
            name: 'Operations',
          },
          {
            value: 'Organizational development',
            intlKey:
              'smb_acquisition_form.fields.department.options.organizational_development',
            name: 'Organizational development',
          },
          {
            value: 'Procurement',
            intlKey:
              'smb_acquisition_form.fields.department.options.procurement',
            name: 'Procurement',
          },
          {
            value: 'Recruiting and Talent Acquisition',
            intlKey:
              'smb_acquisition_form.fields.department.options.recruitment_talent_acquisition',
            name: 'Recruiting and Talent Acquisition',
          },
          {
            value: 'Sales',
            intlKey: 'smb_acquisition_form.fields.department.options.sales',
            name: 'Sales',
          },
          {
            value: 'Tech & Innovation',
            intlKey:
              'smb_acquisition_form.fields.department.options.tech_innovation',
            name: 'Tech & Innovation',
          },
        ],
      },
    },
    validations: {
      primitiveType: 'string',
      required: true,
    },
  },
  {
    id: 'companyinfo-number-of-employees',
    name: 'numberOfEmployees',
    label: 'smb_acquisition_form.fields.number_of_employees.placeholder',
    componentType: 'select',
    columnSize: {
      small: 12,
      medium: 6,
    },

    items: {
      translation: false,
      defaultElements: {
        insertionMode: 'before', // after, mergeAndSort, clean
        elements: [
          { value: '', name: '' },
          {
            value: '1-20',
            name: '1-20',
          },
          {
            value: '21-50',
            name: '21-50',
          },
          {
            value: '51-100',
            name: '51-100',
          },
          {
            value: '101-500',
            name: '101-500',
          },
          {
            value: '501-1000',
            name: '501-1000',
          },
          {
            value: '1001-2500',
            name: '1001-2500',
          },
          {
            value: '2501-5000',
            name: '2501-5000',
          },
          {
            value: '5001-9999',
            name: '5001-9999',
          },
          {
            value: '10000+',
            name: '10000+',
          },
        ],
      },
    },
    validations: {
      primitiveType: 'string',
      required: true,
    },
    actions: {
      onChange: (setValue, clearErrors) => ([selectedItem]) => {
        const valuesToInputTheExactlyNumberOfEmployees = [
          '1-20',
          '21-50',
          '51-100',
          '101-500',
        ]

        const employeesNumberInput = document.getElementById(
          'dynamic-input-employees-number'
        )

        if (
          valuesToInputTheExactlyNumberOfEmployees.some(
            elem => elem === selectedItem.target.value
          )
        ) {
          setValue('employeesNumber', '')
          employeesNumberInput.style.visibility = 'visible'
        } else {
          setValue('employeesNumber', 501)
          employeesNumberInput.style.visibility = 'hidden'
        }

        clearErrors('employeesNumber')

        if (selectedItem.target.value === '51-100') {
          openChat(15000)
        }

        if (selectedItem.target.value) {
          sendSegmentEvent('dropdown_selected', {
            component_category: 'number_of_employees',
            country_name: 'US',
            event_category: 'unlogged_enterprise',
            page_name: 'company_info',
            selected_value: selectedItem.target.value,
          })
        }

        return selectedItem
      },
    },
  },
  {
    id: 'employees-number',
    name: 'employeesNumber',
    label: 'smb_acquisition_company_info.fields.employee_number.placeholder',
    visibility: 'hidden',
    componentType: 'input',
    columnSize: {
      small: 12,
      medium: 6,
    },
    validations: {
      primitiveType: 'number',
      required: true,
      typeError: true,
      positive: true,
      integer: true,
      employeesNumberInRange: true,
    },
    customValidations: [
      {
        key: 'employeesNumberInRange',
        type: yup.number,
        test(employeesNumber) {
          const valuesToInputTheExactlyNumberOfEmployees = [
            '1-20',
            '21-50',
            '51-100',
            '101-500',
          ]
          const { numberOfEmployees } = this.parent

          if (
            !valuesToInputTheExactlyNumberOfEmployees.some(
              elem => elem === numberOfEmployees
            )
          ) {
            return true
          }
          if (employeesNumber && numberOfEmployees) {
            const [min, max] = numberOfEmployees.split('-')

            return employeesNumber >= min && employeesNumber <= max
          }
          return false
        },
      },
    ],
  },
]
